import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RequirementService } from '@services/requirement.service';
import { ConfirmActionModalComponent } from "@app/trackvision/shared/components/confirm-action-modal/confirm-action-modal.component";
import { CollaboratorService } from '@services/collaborator.service';
import { UsersService } from '@services/users.service';


@Component({
    selector: 'app-collaborator-requirement',
    templateUrl: './collaborator-requirement.component.html',
    styleUrls: ['./collaborator-requirement.component.scss'],
    standalone: false
})
export class CollaboratorRequirementComponent implements OnInit {

  @Input() requirementId;
  @Input() dataCollaborator;
  @Input() dataUser;
  @Input() isOwner;
  @Input() isCreator;
  _users:any;

  @Output() deleteCollaboratorEmit = new EventEmitter<boolean>();

  constructor(
    private modalService: NgbModal,
    public _requirements: RequirementService,
    private collaboratorService: CollaboratorService,
    public usersService: UsersService,
    ) {

  }

  ngOnInit() {

  }

  //#region Abrir Modal para eliminar colaborador
  openModalToDeleteCollaborator(idCollaborator: number) {

    const confirmModal = this.modalService.open(ConfirmActionModalComponent, { size: 'sm', centered: true });
    confirmModal.componentInstance.message = `¿Deseas eliminar el colaborador del requerimiento?`;
    confirmModal.result.then((confirmed) => {
      if (confirmed) {
        this.deleteCollaborator(idCollaborator);
      }
    }).catch();

    return;
  }
  //#endregion


  //#region  Funcionalidad eliminar a colaborador
  deleteCollaborator(idCollaborator: number) {
    let collaborator = { userid: 0, requirementid: 0 }
    collaborator.userid = idCollaborator
    collaborator.requirementid = this.requirementId

    this.collaboratorService.deleteCollaborator(collaborator).subscribe(
      data => {
        setTimeout(() => this.deleteCollaboratorEmit.emit(true), 1000);
      },
      error => {
        console.error('Error al eliminar colaborador.');
        console.error(error);
      }
    );
  }
  //#endregion


}
